import { Injectable, computed, signal } from '@angular/core';
import { RoutesName, ROUTES_ORDER } from '../../shared/constants/routes-name';

@Injectable({providedIn:'root'})
export class TabsStore {
  readonly selectedTabSignal = signal<number>(0);
  
  setTab(tabIndex:number){
    this.selectedTabSignal.set(tabIndex);
  }

  getRoute(): RoutesName{
    return ROUTES_ORDER[this.selectedTabSignal()];
  }
}
